import { makeStyles } from "@mui/styles";
export default makeStyles((theme: any) => ({
  stepper: {
    padding: theme.spacing(3, 1, 5),
    wordBreak: "inherit",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  pressedButton: {
    backgroundColor: "#5e35b1",
    color: "#ffff",
    border: "ridge",
  },
  unPressedButton: {
    backgroundColor: "#ffff",
    color: "#616161",
    border: "ridge",
    borderWidth: "0.1px",
  },
  pressedTab: {
    backgroundColor: "#5e35b1",
    color: "#ffff",
    fontSize: 15,
  },
  unPressedTab: {
    color: "black",
    fontSize: 15,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
  },
}));
